import { injectIntl, IntlShape } from 'react-intl';
import {
  Card,
  Typography,
  Grid,
  Checkbox,
  ClickAwayListener,
  FormControlLabel,
  FormGroup,
  TextField,
} from '@material-ui/core';
import { resolveLabel } from 'containers/CourtManagerLegalProceedings/Provision/utils';
import { useCallback, useMemo, useState } from 'react';

import { get, isEmpty, uniqueId } from 'lodash';
import { StyledSpan } from 'containers/CourtManagerLegalProceedings/Provision/styled-components';
import { translate } from 'containers/services/translate';
import { RiskNameWrapper } from 'containers/CourtManagerLegalProceedings/Provision/Regulation/styled-components';
import messages from 'containers/CourtManagerLegalProceedings/Provision/Regulation/messages';

import warning from 'images/warning.svg';
import SahamAccordion from 'components/SahamAccordion';
import {
  RISKS,
  RISK_DATA,
} from 'containers/CourtManagerLegalProceedings/Provision/Regulation/constants';
import { Victim } from 'containers/PreOpeningPage/typings';
import { Autocomplete, AutocompleteChangeReason } from '@material-ui/lab';
import {
  AUTO_COMPLETE_CLEAR_OPTION,
  AUTO_COMPLETE_REMOVE_OPTION,
  RISK_NAME,
} from 'containers/CourtManagerLegalProceedings/Provision/constants';
import {
  filterVehicle,
  filterVictim,
} from 'containers/CourtManagerLegalProceedings/utils';
import {
  getVictimNamesByCompareVictimKeys,
  filterMinorVictims,
  getRisks,
} from 'containers/CourtManagerLegalProceedings/Provision/Regulation/utils';
import {
  StyledCard,
  StyledText,
} from 'containers/CourtManagerLegalProceedings/Provision/Regulation/styled-components';
import * as featureService from 'features/fflip-helpers';
import { FEATURES } from 'features/features';
import { ClaimRecapType } from 'typings/claimTypes';

export interface RiskTypesProps {
  intl: IntlShape;
  sagisClaim: any;
  claimRecap: ClaimRecapType;
  setRiskRecap: Function;
  riskRecap: any;
  riskData: any;
  setRiskData: Function;
  setRiskTypes: Function;
  riskTypes: any;
}

export const RiskTypes: React.FC<RiskTypesProps> = ({
  sagisClaim,
  claimRecap,
  riskData,
  setRiskData,
  riskTypes,
  setRiskTypes,
  ...props
}): JSX.Element => {
  const [open, setOpen] = useState({} as any);
  /* istanbul ignore next */
  const closePopper = (item: any) => (event: any) => {
    return setOpen(
      Object.keys(open).reduce((result: any, key: any) => {
        result[key] = false;
        return result;
      }, {}),
    );
  };
  const openPopper = (item: any) => (event: any) => {
    return setOpen({ ...open, [item.id]: true });
  };
  const handleChangeExpanded = (event: React.ChangeEvent<{}>, item: any) => {
    const types = [...riskTypes] as any;
    const currentType =
      types.find((type: any) => type.title === item.title) || {};
    if (!isEmpty(currentType)) {
      const index = types.indexOf(currentType);
      types[index].expand = !item.expand;
      setRiskTypes(types);
    }
  };
  const handleBeneficiary = (victim: Victim) => (
    event: React.ChangeEvent<{}>,
    value: any[],
    reason: AutocompleteChangeReason,
  ) => {
    const riskRecap = [...props.riskRecap];

    const currentRisk =
      riskRecap.find((risk: any) => risk.riskName === RISK_NAME.CORPOREAL) ||
      {};
    const currentVictim =
      get(currentRisk, 'data', []).find(
        (item: Victim) => victim.id === item.id,
      ) || {};

    if (currentVictim) {
      //add selected beneficiary
      value.forEach(beneficiary => {
        const foundBeneficiary =
          get(currentVictim, 'beneficiaries', []).find(
            // eslint-disable-next-line array-callback-return
            (el: any) => el.id === beneficiary.id,
          ) || {};
        isEmpty(foundBeneficiary) &&
          get(currentVictim, 'beneficiaries', []).push(beneficiary);
      });
      //remove beneficiary
      get(currentVictim, 'beneficiaries', []).forEach((beneficiary: any) => {
        const foundBeneficiary =
          value.find((el: any) => el.id === beneficiary.id) || {};
        /* istanbul ignore next */
        if (
          reason === AUTO_COMPLETE_REMOVE_OPTION &&
          isEmpty(foundBeneficiary)
        ) {
          const beneficiaries = get(currentVictim, 'beneficiaries', []).filter(
            (item: any) => item.id !== beneficiary.id,
          );
          currentVictim.beneficiaries = beneficiaries;
        }

        //clear all
        /* istanbul ignore next */
        if (reason === AUTO_COMPLETE_CLEAR_OPTION && isEmpty(foundBeneficiary))
          currentVictim.beneficiaries = [];
      });
      props.setRiskRecap(riskRecap);
    }
  };
  const handleItemCheckBox = (item: any, type: string) => (
    event: React.ChangeEvent<{ value: string; checked: boolean }>,
  ) => {
    const riskRecap = [...props.riskRecap];
    RISKS.map(
      // eslint-disable-next-line array-callback-return
      (element: any) => {
        if (get(element, 'item', '') === type) {
          const currentRisk =
            riskRecap.find((risk: any) => risk.riskName === element.riskName) ||
            {};
          const index = riskRecap.indexOf(currentRisk);
          const data = { ...riskData };
          const currentType = data[type];

          const riskElement =
            currentType.find(
              (riskElement: any) => riskElement.id === item.id,
            ) || {};

          if (event.target.checked) {
            get(riskRecap[index], 'data', []).push({
              ...item,
              beneficiaries: [],
            });
            props.setRiskRecap(riskRecap);
          } else {
            const itemAlreadyExists =
              get(currentRisk, 'data', []).find(
                (data: any) => data.id === item.id,
              ) || {};
            if (itemAlreadyExists) {
              riskRecap[index].data.splice(
                get(currentRisk, 'data', []).indexOf(itemAlreadyExists),
                1,
              );

              props.setRiskRecap(riskRecap);
            }
          }

          if (!isEmpty(riskElement)) {
            const index = currentType.indexOf(riskElement);
            currentType[index] = {
              ...currentType[index],
              checked: !get(currentType[index], 'checked', false),
            };

            setRiskData(data);
          }
        }
      },
    );
  };
  const renderDataRisk = (element: any) => {
    if (element.title === RISK_DATA.VICTIMS) {
      return featureService.hasFeature(FEATURES.JUDGEMENT_ON_MERITS_INFO)
        ? filterVictim(riskData[element.title])
        : filterMinorVictims(
            filterVictim(riskData[element.title]),
            get(sagisClaim, 'lossDate'),
          );
    } else if (element.title === RISK_DATA.VEHICLES) {
      return filterVehicle(riskData[element.title]);
    } else {
      return riskData[element.title];
    }
  };

  const selectAll = useCallback(
    (element: any) => {
      const data = { ...riskData };
      const currentType = renderDataRisk(element);
      const riskRecap = [...props.riskRecap];
      RISKS.map(
        // eslint-disable-next-line array-callback-return
        (item: any) => {
          if (get(item, 'item', '') === element.title) {
            const currentRisk =
              riskRecap.find((risk: any) => risk.riskName === item.riskName) ||
              {};
            const foundRiskType =
              currentRisk.data.find((type: any) =>
                currentType.map((data: any) => type.id === data.id),
              ) || {};
            if (!isEmpty(foundRiskType)) {
              currentRisk.data = [];
              return props.setRiskRecap(riskRecap);
            }
            currentRisk.data = currentType;
            props.setRiskRecap(riskRecap);
          }
        },
      );
      if (
        !isEmpty(
          data[element.title].find((riskType: any) => riskType.checked) || {},
        )
      ) {
        data[element.title] = renderDataRisk(element).map((riskType: any) => ({
          ...riskType,
          checked: false,
        }));
        return setRiskData(data);
      }
      data[element.title] = renderDataRisk(element).map((riskType: any) => ({
        ...riskType,
        checked: true,
      }));
      setRiskData(data);
    },
    [riskData],
  );
  const { rcCorpo } = useMemo(() => getRisks(props.riskRecap), [
    props.riskRecap,
  ]);

  return (
    <main>
      {riskTypes.map((element: any) => (
        <SahamAccordion
          key={uniqueId(element.title)}
          title={element.message}
          expanded={element.expand}
          onChange={_ => handleChangeExpanded(_, element)}
          accordionDetailsClassName="risk-content"
        >
          <RiskNameWrapper>
            <>
              {element.title === RISK_DATA.VICTIMS &&
                !isEmpty(
                  getVictimNamesByCompareVictimKeys(
                    get(sagisClaim, 'victims', []),
                    renderDataRisk(element),
                  ),
                ) &&
                getVictimNamesByCompareVictimKeys(
                  get(sagisClaim, 'victims', []),
                  renderDataRisk(element),
                ).map((el: string) => (
                  <Card style={StyledCard} elevation={0}>
                    <Grid
                      container
                      direction="row"
                      spacing={1}
                      alignItems="center"
                    >
                      <Grid item>
                        <img src={warning} />
                      </Grid>
                      <Grid item xs>
                        <Typography style={StyledText}>
                          {translate({ ...messages.warningVictim }, props, {
                            victimName: el,
                          })}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Card>
                ))}
            </>
            <FormGroup>
              <StyledSpan
                data-testid="selectAll"
                onClick={() => selectAll(element)}
              >
                {translate(messages.selectAll, props)}
              </StyledSpan>

              {renderDataRisk(element).map((item: any) => (
                <div key={uniqueId()}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        id={'victims'}
                        checked={item.checked}
                        color="primary"
                        onChange={handleItemCheckBox(item, element.title)}
                      />
                    }
                    label={resolveLabel(item)}
                  />
                  {item.checked && !isEmpty(get(item, 'beneficiaries', [])) && (
                    <FormGroup className="content-item">
                      <article>
                        <h4 className="accordion-title">
                          {translate(messages.beneficiaryTitle, props)}
                        </h4>
                      </article>
                      <ClickAwayListener onClickAway={closePopper(item)}>
                        <Autocomplete
                          className="beneficiary-item"
                          multiple
                          id="beneficiaries"
                          options={get(item, 'beneficiaries', [])}
                          getOptionLabel={(option: any) =>
                            `${option.lastName} ${option.firstName}`
                          }
                          value={get(
                            get(rcCorpo, 'data', []).find(
                              (victim: Victim) => victim.id === item.id,
                            ) || {},
                            'beneficiaries',
                            [],
                          )}
                          open={open[item.id]}
                          onFocus={_ => openPopper(item)(_)}
                          onChange={handleBeneficiary(item)}
                          renderInput={params => (
                            <TextField {...params} variant="standard" />
                          )}
                          disablePortal
                          renderOption={_ => (
                            <li {...props}>
                              <Checkbox
                                color="primary"
                                style={{ marginRight: 8 }}
                                checked={get(
                                  get(rcCorpo, 'data', []).find(
                                    (victim: Victim) => victim.id === item.id,
                                  ) || {},
                                  'beneficiaries',
                                  [],
                                ).some((el: any) => el?.id === _?.id)}
                              />

                              {`${_.lastName} ${_.firstName}`}
                            </li>
                          )}
                        />
                      </ClickAwayListener>
                    </FormGroup>
                  )}
                </div>
              ))}
            </FormGroup>
          </RiskNameWrapper>
        </SahamAccordion>
      ))}
    </main>
  );
};

export default injectIntl(RiskTypes);
